export enum SystemTypeEnum {
  DEMO = 'DEMO',
  PRODUCTION = 'PRODUCTION'
}
